import React from 'react';
import { Link } from 'react-router-dom';
import { Header, Footer } from '../components/Layout';
import {
  ArrowLeft, BookOpen, Wallet, Swords, Shield, CreditCard, UserCheck, Bell, MessageSquare
} from 'lucide-react';

const TOPICS = [
  {
    icon: BookOpen,
    title: 'Getting Started',
    desc: 'Create your account, claim 100 free Qbean tokens, and place your first bet.',
    items: ['Sign up and KYC', 'Your free 100 Qbean welcome bonus', 'How matches work'],
  },
  {
    icon: Wallet,
    title: 'Qbean Wallet & Escrow',
    desc: 'Understand our Qbean token (QBC), escrow system and wallet balances.',
    items: ['What are Qbean tokens?', 'Reading your wallet', 'How escrow protects you'],
  },
  {
    icon: Swords,
    title: 'Peer-to-Peer Betting',
    desc: 'Learn the full bet lifecycle — from creation to resolution.',
    items: ['Initiator vs Challenger', 'Public vs Private bets', 'Resolving and dispute flow'],
  },
  {
    icon: Shield,
    title: 'Rock Paper Scissors (RPS)',
    desc: 'The commit-reveal duel: how to play, camera rules, and moderators.',
    items: ['Commit-reveal cryptography', '60-second WebRTC duel', 'Best-of-three and tie-breaks'],
  },
  {
    icon: CreditCard,
    title: 'Deposits & Withdrawals',
    desc: 'Supported payment methods, fees, processing times and limits.',
    items: ['Stripe & PayPal (coming soon)', 'Crypto options', 'Withdrawal verification'],
  },
  {
    icon: UserCheck,
    title: 'KYC & Verification',
    desc: 'Why we verify your identity and how to submit documents quickly.',
    items: ['Required documents', 'Review times', 'What to do if rejected'],
  },
  {
    icon: Bell,
    title: 'Notifications & Alerts',
    desc: 'Stay on top of matches, resolutions and wallet movements.',
    items: ['In-app notifications', 'Email alerts', 'Turning alerts on/off'],
  },
  {
    icon: MessageSquare,
    title: 'Support & Disputes',
    desc: 'Raise a ticket, escalate a bet, or contact a human moderator.',
    items: ['Opening a ticket', 'Response times', 'Moderator escalation'],
  },
];

const HelpCentrePage = () => (
  <div className="min-h-screen bg-[#1A1A1A] flex flex-col">
    <Header />
    <main className="flex-1 max-w-5xl mx-auto px-4 py-8 w-full" data-testid="help-centre-page">
      <Link to="/" className="flex items-center gap-2 text-gray-400 hover:text-white mb-6 text-sm">
        <ArrowLeft className="h-4 w-4" /> Back to Home
      </Link>
      <h1 className="text-3xl font-black uppercase text-white mb-2" style={{ fontFamily: 'Outfit' }}>
        Help <span className="text-[#D4AF37]">Centre</span>
      </h1>
      <p className="text-gray-400 mb-8 text-sm">Find answers, walkthroughs and tips — or jump straight to Contact Us if you need a human.</p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {TOPICS.map((t) => {
          const Icon = t.icon;
          return (
            <div key={t.title} className="card-dark">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-lg bg-[#D4AF37]/15 border border-[#D4AF37]/30 flex items-center justify-center flex-shrink-0">
                  <Icon className="h-5 w-5 text-[#D4AF37]" />
                </div>
                <div className="min-w-0">
                  <h3 className="text-white font-bold text-lg">{t.title}</h3>
                  <p className="text-sm text-gray-400 mt-1">{t.desc}</p>
                  <ul className="mt-3 space-y-1.5 text-sm text-gray-300">
                    {t.items.map((item) => (
                      <li key={item} className="flex items-start gap-2">
                        <span className="text-[#D4AF37] mt-1">›</span><span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="mt-10 card-dark text-center" data-testid="help-cta">
        <h3 className="text-xl font-bold text-white mb-2">Still stuck?</h3>
        <p className="text-sm text-gray-400 mb-4">Our support team typically replies within 1 hour, 24/7.</p>
        <div className="flex flex-col sm:flex-row justify-center gap-3">
          <Link to="/contact" className="btn-primary">Contact Us</Link>
          <Link to="/faq" className="tab-3d text-white">Check FAQ</Link>
        </div>
      </div>
    </main>
    <Footer />
  </div>
);

export default HelpCentrePage;
